import { createReducer } from 'store/helpers';
import {
  ADD_SENT_EMAIL,
  ADD_TO_QUEUE,
  CLEAR_ERROR,
  FINISHED_QUEUE,
  REQUEST_COMPLETED,
  REQUEST_STARTED,
  SENDING_FAILED,
  SET_EMAILS,
  SET_ERROR,
  SET_GMAIL_ACCOUNTS,
  SET_EMAIL_TYPES,
} from 'store/actions/emails';
import { addIdPrefix } from 'services/common';

const initialState = {
  sentEmailIds: [],
  error: '',
  emails: [],
  isFetching: false,
  lastScheduledId: 0,
  requestCount: 0,
  gmailAccounts: [],
  emailTypes: [],
};

const setError = (state, { error }) =>
  state.merge({ error: addIdPrefix(error) });

const clearError = state => state.merge({ error: '' });

const requestStarted = state => state.merge({ isFetching: true });

const requestCompleted = state => state.merge({ isFetching: false });

const addSentEmail = (state, { emailId }) =>
  state.merge({
    sentEmailIds: [].concat(state.sentEmailIds, emailId),
  });

const setEmails = (state, { emails }) => state.merge({ emails });

const sendingFailed = (state, { error }) =>
  state.merge({ error, isSending: false });

const addToQueue = (state, { scheduledId }) =>
  state.merge({
    lastScheduledId:
      scheduledId > state.lastScheduledId ? scheduledId : state.lastScheduledId,
    requestCount: state.requestCount + 1,
  });

const finishedQueue = state =>
  state.merge({ lastScheduledId: 0, requestCount: 0 });

const setGmailAccounts = (state, { gmailAccounts }) =>
  state.merge({ gmailAccounts });

const setEmailTypes = (state, { emailTypes }) => state.merge({ emailTypes });

const handlers = {
  [SET_ERROR]: setError,
  [CLEAR_ERROR]: clearError,
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [SET_EMAILS]: setEmails,
  [SENDING_FAILED]: sendingFailed,
  [ADD_SENT_EMAIL]: addSentEmail,
  [ADD_TO_QUEUE]: addToQueue,
  [FINISHED_QUEUE]: finishedQueue,
  [SET_GMAIL_ACCOUNTS]: setGmailAccounts,
  [SET_EMAIL_TYPES]: setEmailTypes,
};

export default createReducer(initialState, handlers);
